import { Child, DomDirective, HostElement } from '@averoachmea/static/core';

/**
 * Searches for elements with the aa-hero attribute and adds functionallity to it
 *
 * @example
 * ```html
 * <div class="hero aa-hero hero__container" aa-hero>
 *  <div
 *    class="hero__image"
 *    style="background-image: url(
 *      'https://avr.imgix.net/-/media/images/adviseurs/home/hero-afbeeldingen/adviseur_home_jht1685.jpg
 *       ?auto=format&fit=crop&rev=6369994F125D4007A13DE33FB4FE05E9&w=1160&h=360&format=auto
 *      ');"
 *  >
 *      <div class="hero__overlay">
 *          <div class="hero__overlay-svg">
 *              <div class="hero__overlay-text">
 *                  <div class="hero-heading aa-hero-heading">Robijn heading title</div>
 *                  <div class="hero-text-block aa-hero-text">
 *                      <a href="/zakelijk" class="hero__link aa-hero-link">Text</a>
 *                  </div>
 *              </div>
 *              <div class="hero__overlay-svg--desktop">
 *                  <svg viewBox="0 22 75 75" width="575" height="660">
 *                      <use xlink:href="#hero-robijn"/>
 *                  </svg>
 *              </div>
 *              <div class="hero__overlay-svg--mobile">
 *                  <svg viewBox="0 10 80 80" width="200" height="200">
 *                      <use xlink:href="#hero-robijn"/>
 *                  </svg>
 *              </div>
 *              <svg class="defs-only" xmlns="http://www.w3.org/2000/svg">
 *                  <symbol id="hero-robijn">
 *                      <polygon fill="#E13214" class="robijn-svg__layer" points="28,0 68,0 96,20 96,48 69,68 28,68 0,48 0,20" />
 *                      <polygon
 *                          fill="#E13214"
 *                          class="robijn-svg__layer robijn-svg__layer--multiply"
 *                          points="33,8 72,8 100,27 100,55 72,75 32,75 5,55 5,27"
 *                      />
 *                      <polygon
 *                          fill="#E13214"
 *                          class="robijn-svg__layer robijn-svg__layer--multiply"
 *                          points="68,0 100,55 32,75 0,20"
 *                      />
 *                  </symbol>
 *              </svg>
 *          </div>
 *      </div>
 *  </div>
 * </div>
 * ```
 *
 */
@DomDirective({
  selector: 'aa-hero',
})
export class HeroDirective {
  /**
   * Reference to the HTMLElement this directive is applied on.
   *
   * @property {HTMLElement}
   */
  @HostElement()
  private readonly host: HTMLElement;

  @Child('.aa-hero-heading')
  public readonly heroHeading: HTMLElement;

  @Child('.aa-hero-link')
  public readonly heroLink: HTMLAnchorElement;

  public tempHeading: string;
  public anchorElement: HTMLAnchorElement;

  connected(): void {
    if (!document.getElementsByClassName('sc-edit').length && this.heroHeading && this.heroLink) {
      this.tempHeading = this.heroHeading.innerHTML;
      this.checkWindowSize();
      window.addEventListener('resize', () => this.checkWindowSize());
    }
  }

  checkWindowSize() {
    if (window.innerWidth < 576) {
      this.generateHTMLAnchorElement();
    } else {
      this.resetHeading();
    }
  }

  generateHTMLAnchorElement() {
    this.anchorElement = document.createElement('a');
    this.anchorElement.href = this.heroLink.href;
    this.anchorElement.title = this.heroHeading.textContent || '';
    this.anchorElement.classList.add('hero-heading');
    this.anchorElement.classList.add('hero__link');
    this.anchorElement.classList.add('u-text-no-underline');
    this.anchorElement.textContent = this.heroHeading.textContent;
    this.addHTMLAnchorElementToHeading(this.anchorElement);
  }

  addHTMLAnchorElementToHeading(anchorElement: HTMLAnchorElement) {
    this.heroHeading.innerHTML = '';
    this.heroHeading.append(anchorElement);
  }

  resetHeading() {
    this.heroHeading.innerHTML = this.tempHeading;
    if (this.heroHeading.contains(this.anchorElement)) {
      this.heroHeading.removeChild(this.anchorElement);
    }
  }
}
